import { createBillingApi, createDefaultApi } from '../../../utils/createApi';
import { Invoice } from 'fs-api-client';

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const LESS_FILESPACES_COUNT = 3;

export const downloadFile = (filename: string, data: string) => {
    const downloadElement = document.createElement('a');
    downloadElement.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
    downloadElement.setAttribute('download', filename);
    downloadElement.click();
};

export const formatDate = (date: Date) => {
    const dateMonth = date ? date.getMonth() : 0;
    const dateDay = date ? date.getDate() : 0;
    const dateYear = date ? date.getFullYear() : 0;
    const monthName = MONTH_NAMES[dateMonth];
    return `${dateDay} ${monthName} ${dateYear}`;
};

export const downloadCSVBackoffice = async (invoice?: Invoice | null) => {
    if (!invoice) {
        return;
    }
    const api = await createDefaultApi();
    const res = await api.getInvoiceBreakdownCSV(invoice.id);
    downloadFile(invoice.id + '.csv', res.body.toString());
};

export const downloadCSV = async (invoice?: Invoice | null) => {
    if (!invoice) {
        return;
    }
    const billingAPI = await createBillingApi();
    const res = await billingAPI.getInvoiceBreakdownPerFilespace(invoice.id);
    downloadFile(invoice.id + '.csv', res.body.toString());

};



// WEBPACK FOOTER //
// ./src/webportal/components/billing/breakdown/BreakdownModalHelpers.ts